import { patchState, signalStore, withMethods } from "@ngrx/signals";
import { DiagnosisEventService } from "../services/diagnosis-event/diagnosis-event.service";
import { inject } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { HccDetailsDialogComponent } from "../dialogs/hcc-details-dialog/hcc-details-dialog.component";

export const OpportunityListStore = signalStore(
    withMethods((store, service = inject(DiagnosisEventService), dialog = inject(MatDialog), toast = inject(MatSnackBar)) => ({
        setDxEventId(dxEventId: number): void {
            patchState(store, { dxEventId });
        },
        getDxEventHccDetails(hcc: number, dxEventId: number, modelVersionId: number): void {
            if (!dxEventId || !hcc || hcc <= 0 || !modelVersionId || modelVersionId <= 0) {
                toast.open("Invalid Diagnosis Event ID or HCC provided.", undefined, { duration: 3000 });
                return;
            }
            service.getDxEventHccDetails(dxEventId, hcc, modelVersionId).subscribe({
                next: (hccDetails) => {
                    if (!hccDetails || hccDetails.length === 0) {
                        toast.open("No HCC details found", "Close", { duration: 3000 });
                        return;
                    }
                    // Open the dialog with the HCC details
                    dialog.open(HccDetailsDialogComponent, {
                        panelClass: 'dialog-container',
                        data: { fileList: hccDetails, hcc: hcc, hccDescription: hccDetails[0]?.HCCDescription },
                        width: '40dvw',
                        maxHeight: '80dvw',
                    });
                },
                error: () => {
                    toast.open("Failed to load HCC details", undefined, { duration: 3000 });
                }
            });
        }
    })),
);